import { QueryClient, useQuery } from "@tanstack/react-query";
import {
  VenuePageNavGroupRow,
  getVenuePageNavGroups,
} from "../../data/venue_pages_nav_groups";

import { Database } from "@punchup/data/supabase.types";
import { SupabaseClient } from "@supabase/supabase-js";
import { createClientComponentClient } from "@punchup/data/supabase/client";

export function useVenuePageNavGroups(venuePageId: string): {
  navGroups: VenuePageNavGroupRow[];
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
} {
  // The data layer already logs to Sentry and rethrows; no need to wrap.
  const queryFn = async (): Promise<VenuePageNavGroupRow[]> => {
    const supabase = createClientComponentClient<Database>();
    return await getVenuePageNavGroups(supabase, venuePageId);
  };

  const {
    data: navGroups = [],
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["venue-page-nav-groups", venuePageId],
    queryFn,
    staleTime: 5 * 60 * 1000,
  });

  return { navGroups, isLoading, error, refetch };
}

export async function prefetchVenuePageNavGroups(
  queryClient: QueryClient,
  supabase: SupabaseClient<Database>,
  venuePageId: string
) {
  await queryClient.prefetchQuery({
    queryKey: ["venue-page-nav-groups", venuePageId],
    queryFn: async () => {
      return await getVenuePageNavGroups(supabase, venuePageId);
    },
    staleTime: 5 * 60 * 1000,
  });
}
